<template>
  <table
      class="table align-middle table-nowrap mb-0"
      id="customerTable"
  >
    <thead class="table-light">
    <tr>
      <th>محصول</th>
      <th>انبار</th>
      <th>قیمت</th>
      <th>درآمد</th>
      <th scope="col">عملیات</th>
    </tr>
    </thead>
    <tbody class="list form-check-all">
    <tr
        class="gridjs-tr"
        v-for="(data, index) of skeleton"
        :key="index"
    >
      <td data-column-id="product" class="gridjs-td">
                            <span><div class="d-flex align-items-center">
                                <div class="flex-shrink-0 me-3">
                                                                              <Skeletor circle size="48" class="post__avatar" />

                                </div>
                                <div class="flex-grow-1">
                                  <h5 class="fs-14 mb-1">
                                              <Skeletor width="50%" />
                                  </h5>
                                  <p class="text-muted mb-0">
                                    <Skeletor width="75%" />
                                  </p>
                                </div>
                              </div></span
                            >
      </td>
      <td data-column-id="stock" class="gridjs-td">
        <Skeletor width="75%" />
      </td>
      <td data-column-id="price" class="gridjs-td" v-html="data.price_html"></td>
      <td data-column-id="income" class="gridjs-td">
        <Skeletor width="75%" />
      </td>
      <td data-column-id="action" class="gridjs-td">
        <Skeletor width="75%" />
      </td>
    </tr>
    </tbody>


  </table>
</template>

<script>
import { Skeletor } from "vue-skeletor";

export default {
  name: "product-list-skeleton",
  data() {
    return {
      skeleton: 10
    }
  },
  components: {
    Skeletor
  }
}
</script>

<style scoped>

</style>
